import { RouteShipmentsRequestModel } from "api/lokiRequestModels/shipments/RouteShipmentsRequestModel";
import { services } from "api/serviceConfig";
import { makeAutoObservable } from "mobx";
import { ShipmentDetails } from "../models/shipmentDetails/ShipmentDetails";

export class RouteViewStore {
    currentShipmentPage = 1;
    totalLoadedShipmentPages = 1;
    lastShipmentPage = 0;
    shipmentNextToken: string | undefined = undefined;

    shipmentPages: ShipmentDetails[][] = [];

    loadingShipments = false;

    sortShipment: string = "riskLevel";
    directionShipment: "ASC" | "DESC" = "DESC";

    constructor() {
        makeAutoObservable(this);
    }

    get isLastShipmentPage() {
        return this.currentShipmentPage === this.lastShipmentPage;
    }

    get routeName() {
        if (this.shipmentPages.length > 0 && this.shipmentPages[0].length > 0) {
            return this.shipmentPages[0][0].routeName;
        }

        return "";
    }

    get laneName() {
        if (this.shipmentPages.length > 0 && this.shipmentPages[0].length > 0) {
            return this.shipmentPages[0][0].laneName;
        }

        return "";
    }

    moveToPreviousShipmentsPage = () => {
        this.currentShipmentPage--;
    };

    loadFirstShipmentsPage = async (request: RouteShipmentsRequestModel) => {
        this.loadingShipments = true;

        try {
            const response = await services.Shipment.getRouteShipments(request);
            this.clearShipmentPagination();
            if (response.data.shipmentDetails.length > 0) {
                this.shipmentPages.push(response.data.shipmentDetails);
            }
            if (!response.data.nextToken) {
                this.lastShipmentPage = this.currentShipmentPage;
            } else {
                this.shipmentNextToken = response.data.nextToken;
            }
        } catch (error) {
            this.lastShipmentPage = this.currentShipmentPage;
            console.log(error);
        } finally {
            this.loadingShipments = false;
        }
    };

    moveToNextShipmentPage = async (request: RouteShipmentsRequestModel) => {
        this.loadingShipments = true;
        try {
            if (this.totalLoadedShipmentPages === this.currentShipmentPage) {
                const response = await services.Shipment.getRouteShipments(
                    request
                );
                this.shipmentPages.push(response.data.shipmentDetails);
                if (!response.data.nextToken) {
                    this.lastShipmentPage = this.currentShipmentPage + 1;
                } else {
                    this.shipmentNextToken = response.data.nextToken;
                    this.totalLoadedShipmentPages++;
                }
            }
            this.currentShipmentPage++;
        } catch (error) {
            console.log(error);
        } finally {
            this.loadingShipments = false;
        }
    };

    clearShipmentPagination = () => {
        this.shipmentPages = [];
        this.currentShipmentPage = 1;
        this.totalLoadedShipmentPages = 1;
        this.lastShipmentPage = 0;
        this.shipmentNextToken = undefined;
    };

    setShipmentSortProperty = (property: string) => {
        this.sortShipment = property;
    };

    setShipmentDirection = (direction: "ASC" | "DESC") => {
        this.directionShipment = direction;
    };

    resetShipmentsFilters = () => {
        this.sortShipment = "riskLevel";
        this.directionShipment = "DESC";
    };
}
